const ListProductService = function ListProductService() {
    this.suggestedListClickedPreviously = false;
};

module.exports = ListProductService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/lists/listproducts-service.js
 **/